import React from 'react';
import styles from './LoadingSpinner.module.css'; // Import the CSS module

// This component displays a simple spinning circle loading indicator.
const LoadingSpinner = () => {
    return (
        <div className={styles.spinnerContainer} data-testid="loading-spinner">
            {/* The single spinning circle element */}
            <div className={styles.spinner}></div>
            {/* Optional loading text */}
            <p className={styles.spinnerText}>🤲🏽Loading DeenRoute🤲🏽</p>
        </div>
    );
};

export default LoadingSpinner;
